import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/print.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installChunkReloadHandler } from './utils/chunkReload';
import { startVersionWatch } from './utils/versionWatch';
import { installConsoleErrorBuffer } from './utils/screenReview/consoleErrorBuffer';

// Auto-recover from stale code-split chunks after a deploy (see chunkReload.ts).
installChunkReloadHandler();
// Detect new deploys proactively and live-update at safe moments (versionWatch.ts).
startVersionWatch();
// Keep the last few console.error lines for Review Mode notes (screen review).
installConsoleErrorBuffer();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
